// Shared search normalization utility (frontend)
// Trims, collapses whitespace, lowercases, normalizes unicode, replaces dashes

/**
 * Normalize a search string for consistent search behavior.
 * - Trims leading/trailing spaces
 * - Collapses consecutive (including unicode) whitespace to a single space
 * - Converts to lowercase
 * - Normalizes unicode (NFC)
 * - Replaces em-dash/en-dash with hyphen, then hyphens with spaces
 */
export function normalizeSearch(input: string): string {
  if (typeof input !== 'string') return '';
  // Replace em-dash/en-dash with hyphen
  let normalized = input.replace(/[\u2013\u2014]/g, '-');
  // Replace hyphens with spaces for consistent matching
  normalized = normalized.replace(/-/g, ' ');
  // Normalize unicode (NFC)
  normalized = normalized.normalize('NFC');
  // Collapse all unicode whitespace to single space
  normalized = normalized.replace(/\s+/gu, ' ');
  // Trim and lowercase
  normalized = normalized.trim().toLowerCase();
  return normalized;
}
